import useStateStore from 'services/store';
import './float-config-tab.scss';
import {useEffect, useState} from 'react';
import {ConfigDataTab, ProductsDataKeys} from 'services/types';

type FloatConfigTabProps = {
    data: ConfigDataTab | undefined;
};

type TabType = { [key: string]: { id: string; name: string } };

const FloatConfigTab = ({data}: FloatConfigTabProps) => {
    const {
        currentConfig,
        activeProductData,
        activeFabric,
        changeTab,
        setProductFabric,
        runProcedure
    } = useStateStore();

    const [tabs, setTabs] = useState<TabType>();

    useEffect(() => {
        let tabs: { [key: string]: { id: string; name: string } } = {};
        if (data) {
            for (let key in data) {
                tabs[key] = {id: data[key].id, name: data[key].name};
            }
            setTabs(tabs);
        }
        // const val = activeProductData?.[activeFabric]?.[currentConfig as ProductsDataKeys];
    }, [data]);

    const handleChangeTab = (tab: string) => {
        changeTab(tab);
        if (tab === 'short-sleeve') {
            runProcedure('changeCuff', {
                "id": "v-cut-short",
                "img": "images/cuff/short-sleeve.svg",
                "name": "v cut sleeve",
                "tab": "",
                "details": "A customer favorite",
                "price": ""
            })
            setProductFabric({ value: 'v-cut-short' }, 'cuff');
        } else if (tab === 'long-sleeve') {
            runProcedure('changeCuff', {
                "id": "1-button-square",
                "img": "images/cuff/cuff-1.svg",
                "name": "1 button square",
                "tab": "",
                "details": "A customer favorite",
                "price": ""
            })
            setProductFabric({ value: '1-button-square' }, 'cuff');
        }
    };

    return (
        <div className="tabs-container">
            <div className="tab-list">
                {tabs &&
                    Object.keys(tabs)?.map((tab, index) => (
                        <div
                            key={index}
                            className={`tab ${
                                activeProductData?.[activeFabric]?.[
                                    currentConfig as ProductsDataKeys
                                    ].tab === tabs[tab].id
                                    ? 'active'
                                    : ''
                            }`}
                            onClick={() => handleChangeTab(tabs[tab].id)}
                        >
                            {tabs[tab].name}
                        </div>
                    ))}
            </div>
        </div>
    );
};

export default FloatConfigTab;
